import { useRender } from "../../context/renderContext";
import { useIssuesData } from "../../hooks/useIssues";
import IssueDonutCard from "../ui/IssueDonutCard";
const colors = ["#64b5f6", "#ff8a65", "#aed581", "#ffd54f", "#4db6ac", "#ba68c8"];
const PeopleDealingLifeChallenges = () => {
  const { selectedOption, setSelectedOption, options } = useRender();
  const { issuesData } = useIssuesData();
  const handleChange = (event) => {
    setSelectedOption?.(event.target.value);
  };
  const prepareChartData = (lifeChallengesData) => Object.entries(lifeChallengesData ??{}).map(([label, value], index) => ({
    id: index,
    value,
    color: colors[index % colors.length],
    label
  }));
  const chartData = issuesData ? prepareChartData(issuesData.lifeChalengesIssues) : [];
  return <IssueDonutCard
    title="People dealing with life challenges"
    count={issuesData?.lifeChalengesIssuesCount || 0}
    caption="Total users dealing with life challenges"
    chartData={chartData}
    chartTitle="Life Challenges"
    accent="magenta"
    dropdown={{ value: selectedOption, onChange: handleChange, options }}
  />;
};
var PeopleDealingLifeChallenges_default = PeopleDealingLifeChallenges;
export {
  PeopleDealingLifeChallenges_default as default
};